"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const companies = [{
  name: "Tesla",
  description: "Tesla utvecklar sin Full Self-Driving (FSD) mjukvara med målet att skapa ett globalt nätverk av självkörande taxibilar, ofta kallat Cybercab. Deras vision bygger på kamerabaserad vision och artificiell intelligens.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_robotaxi_vision.png"
}, {
  name: "Waymo",
  description: "Waymo, ett dotterbolag till Alphabet, driver redan kommersiella robotaxi-tjänster i flera amerikanska städer. Deras fordon använder en kombination av lidar, radar och kameror för maximal säkerhet.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/waymo_autonomous_vehicle.png"
}, {
  name: "XPeng",
  description: "Den kinesiska tillverkaren XPeng gör snabba framsteg inom autonom körning och planerar att expandera sina avancerade förarassistanssystem globalt, med sikte på fullt självkörande mobilitet.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/xpeng_smart_ev.png"
}];
export default function LeadersInSelfDriving() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="ledarna-inom-självkörning" className="bg-background py-24 px-6 md:px-8">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-primary mb-4">
            Ledarna inom självkörning
          </h2>
          <p className="font-sans text-foreground max-w-2xl mx-auto text-[15px]">
            Teknologin utvecklas i en rasande takt. Här är de tre aktörer som just nu driver utvecklingen framåt och formar framtidens autonoma mobilitet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {companies.map((company, index) => <Card key={company.name} data-index={index} className="group overflow-hidden rounded-[3px] border border-border p-0 gap-0 bg-card shadow-none hover:shadow-md transition-shadow duration-300">
              <div className="overflow-hidden aspect-[4/3] w-full">
                <img src={company.image} alt={`Bild på ${company.name} självkörande bil`} className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
              </div>
              <CardContent className="p-6">
                <h3 className="font-serif text-[22px] font-bold text-primary mb-3">
                  {company.name}
                </h3>
                <p className="font-sans text-[15px] text-foreground leading-relaxed">
                  {company.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}